<div class="modal-header">
  <h4 class="modal-title pull-left">{{'MODALE_CHANGER_MDP.TITRE' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form (ngSubmit)="onSubmit()">
    <input type="text" name="username" value="{{username()}}" autocomplete="username email" style="display: none;">
    <div class="form-group">
      <label for="ancienMdp">{{'MODALE_CHANGER_MDP.ANCIEN_MDP' | translate}}</label>
      <input id="ancienMdp" type="password" [(ngModel)]="ancienMdp" name="ancienMdp" class="form-control" placeholder="{{'MODALE_CHANGER_MDP.ANCIEN_MDP' | translate}}" maxlength="256" required
        autocomplete="current-password" />
        @if (ancienMdpRequis()) {
          <div class="custom-alert custom-alert-sm">{{'MODALE_CHANGER_MDP.ANCIEN_MDP_REQUIS' | translate}}</div>
        }
        @if (ancienMdpInvalide()) {
          <div class="custom-alert custom-alert-sm">{{'MODALE_CHANGER_MDP.ANCIEN_MDP_INVALIDE' | translate}}</div>
        }
      </div>
      <div class="form-group">
        <label for="nouveauMdp">{{'MODALE_CHANGER_MDP.NOUVEAU_MDP' | translate}}</label>
        <input id="nouveauMdp" type="password" [(ngModel)]="nouveauMdp" name="nouveauMdp" class="form-control" placeholder="{{'MODALE_CHANGER_MDP.NOUVEAU_MDP' | translate}}" maxlength="256" required
          autocomplete="new-password" />
          @if (nouveauMdpRequis()) {
            <div class="custom-alert custom-alert-sm">{{'MODALE_CHANGER_MDP.NOUVEAU_MDP_REQUIS' | translate}}</div>
          }
          @if (nouveauMdpLongMini()) {
            <div class="custom-alert custom-alert-sm">{{'MODALE_CHANGER_MDP.NOUVEAU_MDP_LONG_MINI' | translate}}</div>
          }
        </div>
        <div class="form-group">
          <label for="confirmMdp">{{'GLOBAL.CONFIRMER' | translate}}</label>
          <input id="confirmMdp" type="password" [(ngModel)]="confirmMdp" name="confirmMdp" class="form-control" placeholder="{{'GLOBAL.CONFIRMER' | translate}}" maxlength="256" required
            autocomplete="new-password" />
            @if (mdpDifferents()) {
              <div class="custom-alert custom-alert-sm">{{'MODALE_CHANGER_MDP.MDP_DIFFERENTS' | translate}}</div>
            }
            @if (erreurValidation()) {
              <div class="custom-alert custom-alert-sm">{{'MODALE_CHANGER_MDP.ERREUR_VALIDATION' | translate}}</div>
            }
            @if (modifReussie()) {
              <div class="alert alert-success">{{'MODALE_CHANGER_MDP.MODIF_REUSSIE' | translate}}</div>
            }
          </div>
          <div class="btn-toolbar justify-content-between">
            <div class="btn-group" role="group">
              <button type="submit" class="btn btn-outline-success">{{'GLOBAL.ENREGISTRER' | translate}}</button>
            </div>
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
            </div>
          </div>
        </form>
      </div>

      <div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
        <div class="modal-dialog modal-sm">
          <div class="modal-content">
            <div class="modal-body text-center">
              <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
              <button type="button" class="btn btn-primary" (click)="bsModalRef.hide()">{{'GLOBAL.OUI' | translate}}</button>
              <button type="button" class="btn btn-secondary" (click)="modalConfirmCancel.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
